import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import StageDialog from '../StageDialog';

import JobProfile from '../JobProfileDialog';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import Dashboard from '../../../Dashboard';
import { hasPermission } from '../../../../utils/authenticated';
import {
  fetchJobProfilesRoutine,
  removeJobProfilePromise,
  saveJobProfileRoutine
} from '../../../../redux/routines';

import { isDialogVisibleSelector } from '../../../../redux/selectors';
import { JOB_PROFILE_DIALOG, STAGE_DIALOG } from '../../../../redux/constants/dialogs';
import JobProfilesGrid from '../JobProfilesGrid';
import { toJS } from '../../../../utils/helper';
import bindPromiseCreators from 'redux-saga-routines/es/bindPromiseCreators';

class JobProfilesView extends Component {

  componentWillMount() {
    this.setState({
      editable: hasPermission(['Administrator']),
    });
  }

  render() {
    const { isDialogVisible, jobProfiles, fetchJobProfiles, saveJobProfile, removeJobProfile, showDialog } = this.props;

    return (
      <Dashboard title="Job Profiles">
        <JobProfilesGrid
          data={jobProfiles}
          fetch={fetchJobProfiles}
          onEdit={saveJobProfile}
          onRemove={removeJobProfile}
          showDialog={showDialog}
        />

        {isDialogVisible(JOB_PROFILE_DIALOG) ? <JobProfile/> : null}
        {isDialogVisible(STAGE_DIALOG) ? <StageDialog/> : null}
      </Dashboard>
    );
  }
}

JobProfilesView.propTypes = {
  fetchJobProfiles: PropTypes.func.isRequired,
  removeJobProfile: PropTypes.func.isRequired,
  // setJobProfile: PropTypes.func.isRequired,
  jobProfiles: PropTypes.object.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    jobProfiles: toJS(state.getIn(['jobprofiles', 'jobProfiles'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchJobProfiles: fetchJobProfilesRoutine.trigger,
      saveJobProfile: saveJobProfileRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      removeJobProfile: removeJobProfilePromise,
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobProfilesView);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfilesView/index.js